import {
  BuildingOfficeIcon,
  UserIcon,
  DocumentTextIcon,
  BanknotesIcon,
} from "@heroicons/react/24/outline";

import { DiligenceItem } from "./diligence.types";
import { Dividas } from "./tabs/dividas";
import { Documentos } from "./tabs/documentos";
import { Proprietarios } from "./tabs/proprietarios";
import { Processos } from "./tabs/processos";

export const diligenciaItems = [
  {
    id: "dividas",
    label: "Dívidas",
    description:
      "Atalhos para descobrir todas as dívidas de caráter propter rem",
    icon: BanknotesIcon,
    content: (props: DiligenceItem) => <Dividas {...props} />,
  },
  {
    id: "documentos",
    label: "Imóvel",
    description:
      "Alguns documentos importantes de se ter em mão antes e depois de arrematar",
    icon: DocumentTextIcon,
    content: (props: DiligenceItem) => <Documentos {...props} />,
  },
  {
    id: "proprietarios",
    label: "Ex-proprietário",
    description:
      "Consulte informações sobre o antigo proprietário para não ter nenhuma surpresa",
    icon: UserIcon,
    content: (props: DiligenceItem) => <Proprietarios {...props} />,
  },
  {
    id: "processos",
    label: "Processos",
    description:
      "Encontre processos relacionados ao ex-proprietário e ao imóvel",
    icon: BuildingOfficeIcon,
    content: (props: DiligenceItem) => <Processos {...props} />,
  },
];
